import { render, staticRenderFns } from "./confirm-button.vue?vue&type=template&id=0b0008f2"
import script from "./confirm-button.vue?vue&type=script&lang=js"
export * from "./confirm-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports